(() => {
  if (window.loufordFaqNavigationReady) return;
  window.loufordFaqNavigationReady = true;

  const groupSelector = '.LoufordBrandFaq .LoufordInformation__FaqGroup[id^="LoufordFaq-"]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const gap = 24;
  let pendingFrame = 0;

  const groupForHash = hash => {
    if (!hash || !hash.startsWith('#LoufordFaq-')) return null;
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch { return null; }
    const group = document.getElementById(id);
    return group && group.matches(groupSelector) ? group : null;
  };

  const headerOffset = () => {
    const header = document.querySelector('.shopify-section--header');
    if (!header) return 0;
    const style = window.getComputedStyle(header);
    if (style.position !== 'sticky' && style.position !== 'fixed') return 0;
    // The announcement bar scrolls away; only the sticky header covers the destination.
    return header.getBoundingClientRect().height + Math.max(0, parseFloat(style.top) || 0);
  };

  const updateCurrentLink = group => {
    document.querySelectorAll('.LoufordBrandFaq__Aside nav a[href]').forEach(link => {
      const url = new URL(link.href, window.location.href);
      if (group && groupForHash(url.hash) === group) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  };

  const scrollToGroup = (group, behavior, focus) => {
    if (focus) {
      const heading = group.querySelector('h2, h3');
      if (heading) {
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
    }
    // Use document coordinates once. scroll-margin is only the native no-JS fallback.
    const top = group.getBoundingClientRect().top + window.scrollY - headerOffset() - gap;
    window.scrollTo({ left: window.scrollX, top: Math.max(0, top), behavior });
    updateCurrentLink(group);
  };

  const alignCurrentHash = () => {
    window.cancelAnimationFrame(pendingFrame);
    // Let native hash/history restoration and the header's own layout finish first.
    pendingFrame = window.requestAnimationFrame(() => {
      pendingFrame = window.requestAnimationFrame(() => {
        pendingFrame = 0;
        const group = groupForHash(window.location.hash);
        if (group) scrollToGroup(group, 'auto', true);
        else updateCurrentLink(null);
      });
    });
  };

  // Capture before the theme's generic body delegate: it scrolls to offsetTop and ignores the header.
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('.LoufordBrandFaq a[href]') : null;
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.search !== window.location.search) return;
    const group = groupForHash(url.hash);
    if (!group) return;

    event.preventDefault();
    event.stopPropagation();
    window.cancelAnimationFrame(pendingFrame);
    if (window.location.hash !== url.hash) window.history.pushState(null, '', url.hash);
    scrollToGroup(group, reducedMotion.matches ? 'auto' : 'smooth', true);
  }, true);

  window.addEventListener('hashchange', alignCurrentHash);
  window.addEventListener('popstate', alignCurrentHash);
  document.addEventListener('shopify:section:load', alignCurrentHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alignCurrentHash, { once: true });
  else alignCurrentHash();
  if (document.readyState !== 'complete') window.addEventListener('load', alignCurrentHash, { once: true });
})();
